import React from 'react'
import { BasicButton } from '.'
import { Link } from 'react-router-dom'
import ROUTES from '../../application/utils/Routes'
import { AgentsDropdown } from '../containers'

function FormsTopbar({selectedAgents, setSelectedAgents}) {



    return (
        <div className="flex justify-between">
            <div>
                <AgentsDropdown valueUpdater={setSelectedAgents}/>
                </div>

            <Link to={ROUTES.ADDFORM}>
                <BasicButton text="New Form"/>
            </Link>

        </div>
    )
}

export default FormsTopbar